<template>
  <div></div>
</template>

<script>
export default {
  name: 'Home',
  mounted() {
    this.$router.push('/routing-status');
  }
};
</script>

<style lang="scss" scoped></style>
